<template>
    <!-- 顶部搜索组件 -->
    <div class="search-dropdown">
        <div class="search-input-box">
            <div class="btn-box">
                <img class="search-btn" src="@/assets/assetsNew/header/search1.png"></img>
            </div>
            <el-input class="no-border" placeholder="Search" v-model="searchValue"></el-input>
            <div class="btn-box">
                <i class="el-icon-close icon-lg" @click="closeSearch"></i>
            </div>
        </div>
    </div>
</template>
<script> 
export default {
    name: 'search-dropdown',
    data() {
        return {
            searchValue: ''
        }
    },
    methods: {
        closeSearch(){
            this.$emit('closeSearch', false)
        }
    }
}
</script>
<style scoped>
.search-dropdown{
    background: #ffffff;
    width: 100%;
    position: fixed;
    top:53px;
}
.search-input-box{
    padding: 30px 60px;
    display: flex;
    align-items: center;
}
.btn-box{
    width: 44px;
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.search-btn{
    width: 20px;
    height: 20px;
}
.icon-lg{
    font-size: 20px;
    cursor: pointer;
}
.no-border .el-input__inner {
  border: 0 !important;          /* 去掉默认 1px 边框 */
  outline: none !important;      /* 去掉 focus 时的 outline */
  box-shadow: none !important;   /* 去掉主题色 focus 高亮 */
}
</style>